import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestProductsChoicesStylesUS: DomainsBaseStyles = {
  ...defaultStyles,

  COMMONS_APPBAR_BG: 'bg-[#08284b]',
  COMMONS_FOOTER_BG: 'bg-[#08284b]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#08284b] hover:border-[#08284b] hover:bg-[#08284b] text-white',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#08284b]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#08284b]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#08284b]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#08284b] text-[#08284b] [&>svg>path]:stroke-[#08284b] [&>svg>g>path]:stroke-[#08284b] [&>svg>path]:fill-[#08284b] [&>svg>g>path]:fill-[#08284b]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#08284b] text-[#08284b] [&>svg>path]:stroke-[#13375f] [&>svg>g>path]:stroke-[#13375f] [&>svg>path]:fill-[#13375f] [&>svg>g>path]:fill-[#13375f]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#08284b]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#08284b]',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#08284b]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#08284b]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#08284b]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-black [&>svg>g>path]:fill-black',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-black [&>svg>g>path]:stroke-black',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#9ec3ec] [&>.vector-top>path]:fill-[#08284b] [&>.vector-bottom>path]:fill-[#08284b]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#9ec3ec] [&>circle]:stroke-[#9ec3ec] [&>path]:fill-[#08284b]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#13375f] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#13375f] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#13375f]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#13375f] [&_path]:fill-[#13375f] [&_path]:stroke-[#13375f]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#13375f]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#13375f]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#13375f]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#13375f]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#13375f]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#9ec3ec]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#9ec3ec]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#9ec3ec]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#9ec3ec]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#9ec3ec]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#9ec3ec]',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#e3ecf7]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#e3ecf7] text-black',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#e3ecf7]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#e3ecf7]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#e3ecf7]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-black',
}
